module.exports = __webpack_public_path__ + "static/media/diktat-9.1bbd0f01.mp3";